import { Link } from 'react-router-dom'

import {
  Box,
  Columns,
  Col,
  Heading,
  IconButton,
  Skeleton,
  Text,
} from '@redriverpress/system'
import useVideoGenres from '../../hooks/useVideoGenres'

const GenreHeaderSkeleton = () => (
  <Box>
    {/* Heading */}
    <Skeleton height='3rem' width={1 / 2} mb={2} />
    {/* Videos count */}
    <Skeleton height='1.6rem' width={1 / 4} mb={4} />
  </Box>
)

export default function GenreHeader() {
  const { activeGenre, previousGenre, nextGenre } = useVideoGenres()

  if (activeGenre) {
    return (
      <Columns alignItems='top' mb={4}>
        <Col width={[1, null, 3 / 4]}>
          <Heading as='h2' mb={2}>
            {activeGenre.title}
          </Heading>
          <Text>{`${activeGenre.videosCount.toLocaleString()} ESL videos`}</Text>
        </Col>
        <Col
          width={[null, null, 1 / 4]}
          display={['none', null, 'flex']}
          justifyContent='flex-end'
        >
          <IconButton
            as={Link}
            icon='chevron-left'
            aria-label={`Previous Genre: ${previousGenre.title}`}
            title={`Previous Genre: ${previousGenre.title}`}
            to={`/videos/${previousGenre.slug}`}
            mr={2}
          />
          <IconButton
            as={Link}
            icon='chevron-right'
            aria-label={`Next Genre: ${nextGenre.title}`}
            title={`Next Genre: ${nextGenre.title}`}
            to={`/videos/${nextGenre.slug}`}
          />
        </Col>
      </Columns>
    )
  }
  return <GenreHeaderSkeleton />
}
